import { render, staticRenderFns } from "./CollegeSetting.vue?vue&type=template&id=4bdbdb51"
import script from "./CollegeSetting.vue?vue&type=script&lang=js"
export * from "./CollegeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports